import styled from '@emotion/styled';
import { getSpacing } from '@cabonline/ui-shared';
import { ButtonRowAlign } from './types';

export interface StyledButtonRowProps {
  align: ButtonRowAlign;
}

export const StyledButtonRow = styled.div<StyledButtonRowProps>`
  display: flex;
  gap: ${getSpacing('m')};
  justify-content: ${({ align }) =>
    align === 'end' ? 'flex-end' : align === 'start' ? 'flex-start' : align};
  margin-top: ${getSpacing('l')};
`;
